import { ConditionEqualityType } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";

export const conditionOperatorOptions: { value: ConditionEqualityType; caption: string }[] = [
  { value: ConditionEqualityType.Equal, caption: "Is Filtered by" },
  { value: ConditionEqualityType.NotEqual, caption: "Is Not Filtered by" },
  { value: ConditionEqualityType.Contains, caption: "Contains" },
  { value: ConditionEqualityType.DoesntContain, caption: "Doesn't Contain" },
];

//Kept in step with TextConditionOperands.MaxOperandLength on the server.
export const MAX_CONDITION_TEXT_LENGTH = 250;

const textOperators = [ConditionEqualityType.Contains, ConditionEqualityType.DoesntContain];

export const isTextOperator = (equalityType?: ConditionEqualityType): boolean =>
  equalityType !== undefined && textOperators.includes(equalityType);
